import { useEffect, useState, useRef } from "react";
import { Button, Grid, TextField, Typography } from "@mui/material";
import React from "react";
import { TablePaginate } from "../../../layout/Datagrid/TablePaginate";
import { useNavigate, useParams } from "react-router-dom";
import BreadcrumbBar from "../../../layout/BreadcrumbBar";
import { EditarTitulo, FlujoMontos, mostrarDatosDetalle } from "../../../services/PpafeServices";
import getColumnsVerificacionPF from "../../../layout/Columns/ColumnsVerificacionMontosPF";
import Swal from "sweetalert2";
import { flujoEnum } from "../../../types/enumTypes";
import { puedeActualizar } from "../../../utils/permisosFlujo";
import { Download } from "@mui/icons-material";
import * as XLSX from 'xlsx';


const VerificacionMontosPF = () => {
    const { id } = useParams<{ id: string }>();
    const [titulo, setTitulo] = useState<string>("");
    const [currentPage, setCurrentPage] = React.useState(1);
    const [perPage, setPerPage] = React.useState(100);
    const [dataLoading, setDataLoading] = useState(false);
    const navigate = useNavigate();
    const [estatus, setEstatus] = useState<flujoEnum>(flujoEnum.oculto); // Nuevo estado para el estatus
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [responseData, setResponseData] = useState<any[]>([]);
    const scrollRef = useRef<HTMLDivElement>(null);
    const [modoEdicionTitulo, setModoEdicionTitulo] = useState(false);

    useEffect(() => {
        if (responseData.length > 0) {
            scrollRef.current?.scrollIntoView({ behavior: "smooth" });
        }
    }, [responseData]);

    const handleVerClick = (id: string, link: string) => {
        navigate("/" + link + "/alta/" + id);
    };

    const columns = getColumnsVerificacionPF({ handleVerClick, urlOrigen: '/usuarios/listado', rows: Array.isArray(responseData) ? responseData : [] });

    const flujoDetalle = (accion: "avanzar" | "devolver") => {
        const tipo = "participaciones";
        const origen = "federales";
        FlujoMontos(tipo, origen, setLoading, setResponseData, setError, estatus, id || "", accion);
    };

    const editar = () => {
        const tipo = "participaciones";
        const origen = "federales";
        EditarTitulo(tipo, origen, setLoading, setResponseData, ObtenerDatosDetalle, setError, id || "", titulo);
    };

    const ObtenerDatosDetalle = () => {
        const tipo = "participaciones"; // Aquí puedes cambiarlo dinámicamente
        const origen = "federales"; // También puedes pasarlo según la pantalla
        mostrarDatosDetalle(tipo, origen, setLoading, setResponseData, setError, setTitulo, setEstatus, id || "");
    };

    useEffect(() => {
        ObtenerDatosDetalle();
    }, []); // Dependencias vacías para ejecutarse solo al montar el componente

    const getEstatusCorrecto = (estatus: string) => {
        const estatusLower = estatus.toLowerCase(); // Convertimos todo a minúsculas
        switch (estatusLower) {
            case "revision":
                return "Revisión";
            case "validacion":
                return "Validación";
            case "publicado":
                return "Publicado";
            case "devuelto":
                return "Devuelto";
            case "oculto":
                return "Oculto";
            default:
                return estatus.toUpperCase(); // En caso de que el estatus no esté en los casos anteriores
        }
    };

    const obtenerTextoBoton = () => {
        switch (estatus) {
            case "REVISION":
                return "Validar";
            case "VALIDACION":
                return "Publicar";
            case "PUBLICADO":
                return "Publicado"; // O puedes devolver un texto diferente si es necesario
            case "OCULTO":
                return "revisar";
            case "DEVUELTO":
                return "revisar";
            default:
                return "Guardar"; // Si no hay estatus, por defecto
        }
    };

    const TITULO = estatus ? `${getEstatusCorrecto(estatus)} de Montos` : "Validación de Montos";

    const exportToExcel = () => {
        if (!responseData || responseData.length === 0) {
            console.warn("No hay datos para exportar.");
            return;
        }
        // Definir los encabezados personalizados
        const formatNumber = (num: string | number | null | undefined) => {
            if (num === undefined || num === null || num === "") return "0.00";

            // Si es string, quitar comas y convertir a número
            if (typeof num === 'string') {
                num = num.replace(/,/g, '');
                num = parseFloat(num);
            }
            // Si es número válido, formatear
            return !isNaN(num)
                ? num.toFixed(2) // <- Aquí se evita el uso de toLocaleString
                : "0.00";
        };
        const tituloReporte = [[titulo]];
        // 🔹 Mapear los datos asegurando que coincidan con los encabezados
        const allColumns = [
            { field: "municipio", header: "Municipios" },
            { field: "FGP", header: "Fondo General Participaciones" },
            { field: "70% FFM", header: "Fondo de Fomento Municipal 70 % (FFM70)" },
            { field: "30% FFM", header: "Fondo de Fomento Municipal 30 % (FFM30)" },
            { field: "IEPS", header: "Impuesto Especial sobre la Producción y los Servicios (IEPS)" },
            { field: "FOFIR", header: "Fondo de Fiscalización y Recaudación" },
            { field: "ISAN", header: "Impuesto sobre Automóviles Nuevos (ISAN)" },
            { field: "COMP ISAN", header: "Fondo de Compensación de ISAN" },
            { field: "IEPSGYD", header: "Impuesto Especial sobre la Venta Final de Gasolina y Diésel (IEPSGyD)" },
            { field: "FEXHI", header: "Fondo de Extracción de Hidrocarburos" },
            { field: "ISR SALARIOS", header: "ISR Salarios" },
            { field: "ISR BI", header: "ISR por Enajenación de Bienes Inmuebles" },
            { field: "TENENCIA", header: "Tenencia" },
            { field: "FEIEF FGP", header: "FEIEF FGP" },
            { field: "FEIEF FOFIR", header: "FEIEF FOFIR" },
            { field: "FEIEF FFM70", header: "FEIEF FFM70" },
            { field: "FEIEF IEPS", header: "FEIEF IEPS" },
            { field: "total_monto", header: "Totales" }
        ];
        // 🔥 Filtrar columnas donde NO sean todos ceros
        const validColumns = allColumns.filter(({ field }) => {
            // municipio siempre debe incluirse
            if (field === "municipio") return true;
            // Validar que haya algún dato diferente de 0 para esta columna
            return responseData.some(item => {
                const value = item[field];
                if (value === undefined || value === null || value === "") return false;
                let numericValue = typeof value === 'string' ? parseFloat(value.replace(/,/g, '')) : value;
                // Si no es un número, no lo consideramos
                if (isNaN(numericValue)) return false;
                // Solo es válido si es distinto de cero
                return numericValue !== 0;
            });
        });
        // Crear encabezados dinámicos basados en columnas válidas
        const headers = [validColumns.map(col => col.header)];
        // Mapear los datos asegurando que coincidan con los encabezados válidos
        const formattedData = responseData.map((item) =>
            validColumns.map(({ field }) => {
                if (field === "municipio") return item.municipio || "";
                return formatNumber(item[field]);
            })
        );
        // Crear hoja de Excel con los datos obtenidos
        const ws = XLSX.utils.aoa_to_sheet([...tituloReporte, ...headers, ...formattedData]);
        ws['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: headers[0].length - 1 } }];
        ws["A1"].s = {
            font: { bold: true, sz: 14 },
            alignment: { horizontal: "center" }
        };
        ws['!cols'] = Array(headers[0].length).fill({ wch: 25 });
        // Crear un libro de trabajo y agregar la hoja
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Datos");
        // Escribir el archivo en un Blob
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        // Crear un enlace de descarga y activarlo automáticamente
        const fileName = "Reporte_Datos.xlsx";
        const url = URL.createObjectURL(data);
        const link = document.createElement("a");
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        // Limpiar memoria
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    return (
        <Grid container>
            <Grid item mb={2} width={"100%"}>
                <BreadcrumbBar
                    links={[
                        { texto: "Inicio", link: "/admin" },
                        { texto: "Montos", link: "/admin/participaciones/federales/montos" },
                    ]}
                    Titulo={TITULO}
                />
            </Grid>
            <Grid item mb={2} width={"100%"} >
                <Typography
                    variant="h5"
                    component="div"
                    sx={{
                        flexGrow: 1,
                        fontWeight: "bold",
                        display: "flex",
                        justifyContent: "left",

                    }}
                >
                    {estatus ? `${getEstatusCorrecto(estatus)} de Montos` : "de Montos"}
                </Typography>

                <Grid item width={"100%"}>
                    {estatus === "DEVUELTO" && modoEdicionTitulo ? (
                        <TextField
                            variant="outlined"
                            fullWidth
                            value={titulo}
                            onChange={(e) => setTitulo(e.target.value)}
                            sx={{
                                fontWeight: "bold",
                            }}
                        />
                    ) : (
                        <Typography
                            variant="h5"
                            component="div"
                            sx={{
                                flexGrow: 1,
                                fontWeight: "bold",
                                display: "flex",
                                justifyContent: "left",
                            }}
                        >
                            {titulo}
                        </Typography>
                    )}
                </Grid>
            </Grid>

            <Grid
                container
                spacing={2}
                justifyContent="space-between"
                alignItems="center"
                sx={{ mb: 2 }}
            >
                <Grid
                    item
                    xs={12}
                    md="auto"
                    display="flex"
                    justifyContent={{ xs: "center", md: "flex-start" }}
                    width="100%"
                >
                    <Button
                        startIcon={<Download />}
                        onClick={exportToExcel}
                        variant="contained"
                        color="primary"
                        fullWidth
                        sx={{
                            maxWidth: { xs: "100%", md: "auto" }, // ocupa todo el ancho en celular
                        }}
                    >
                        Exportar a Excel
                    </Button>
                </Grid>
                <Grid
                    item
                    xs={12}
                    md="auto"
                    display="flex"
                    justifyContent={{ xs: "center", md: "flex-end" }}
                    width="100%"
                >
                    {estatus === "DEVUELTO" && (
                        <Button
                            onClick={() => {
                                if (modoEdicionTitulo) {
                                    editar(); // Solo ejecuta editar cuando ya se está editando
                                    setModoEdicionTitulo(false);
                                } else {
                                    setModoEdicionTitulo(true); // Activa modo edición
                                }
                            }}
                            variant="contained"
                            color="primary"
                            fullWidth
                            sx={{
                                maxWidth: { xs: "100%", md: "auto" }, // ocupa todo el ancho en celular
                            }}
                        >
                            {modoEdicionTitulo ? "Guardar Titulo" : "Editar Titulo"}
                        </Button>
                    )}
                </Grid>
            </Grid>


            <TablePaginate
                rowsInfo={responseData}
                columns={columns}
                Mostrar={false}
                loading={dataLoading}
            />
            <Grid
                container
                spacing={2}
                sx={{ mt: 2 }}
                justifyContent={{ xs: "center", md: "flex-end" }}
            >
                <Grid
                    item
                    xs={12}
                    md="auto"
                    display="flex"
                    justifyContent={{ xs: "center", md: "flex-end" }}
                >
                    <Button
                        sx={{
                            width: { xs: "100%", md: "7rem" },
                            textTransform: "capitalize",
                        }}
                        variant="contained"
                        onClick={() =>
                            navigate("/admin/participaciones/federales/montos")
                        }
                        style={{ backgroundColor: "#C1A25C" }}
                    >
                        Cancelar
                    </Button>
                </Grid>

                {puedeActualizar(estatus) && (
                    <Grid
                        item
                        xs={12}
                        md="auto"
                        display="flex"
                        justifyContent={{ xs: "center", md: "flex-end" }}
                    >
                        <Button
                            variant="contained"
                            color="primary"
                            sx={{
                                width: { xs: "100%", md: "7rem" },
                                textTransform: "capitalize",
                            }}
                            disabled={
                                estatus === "OCULTO" ||
                                estatus === "DEVUELTO"
                            }
                            onClick={() => flujoDetalle("devolver")}
                        >
                            Devolver
                        </Button>
                    </Grid>
                )}

                {puedeActualizar(estatus) && (
                    <Grid
                        item
                        xs={12}
                        md="auto"
                        display="flex"
                        justifyContent={{ xs: "center", md: "flex-end" }}
                    >
                        <Button
                            variant="contained"
                            color="primary"
                            sx={{
                                width: { xs: "100%", md: "7rem" },
                                textTransform: "capitalize",
                            }}
                            disabled={
                                estatus === "PUBLICADO"
                            }
                            onClick={() => flujoDetalle("avanzar")}
                        >
                            {obtenerTextoBoton()}
                        </Button>
                    </Grid>
                )}
            </Grid>

            <div ref={scrollRef} />
        </Grid>
    );
};
export default VerificacionMontosPF;
